import React from 'react';
import {
  classNames,
  layoutClassNames,
  LayoutClassNameProps,
  textClassNames,
  TextClassNameProps,
} from './classNames';

export type TextTone = 'default' | 'muted';
export type TextVariant = 'default' | 'lead' | 'small';

export interface TextProps
  extends React.HTMLAttributes<HTMLElement>,
    LayoutClassNameProps,
    TextClassNameProps {
  as?: React.ElementType;
  tone?: TextTone;
  variant?: TextVariant;
}

const Text: React.FC<TextProps> = ({
  as: Component = 'p',
  tone = 'default',
  variant = 'default',
  className,
  children,
  fontSize,
  fontWeight,
  margin,
  marginTop,
  marginEnd,
  marginBottom,
  marginStart,
  marginX,
  marginY,
  padding,
  paddingTop,
  paddingEnd,
  paddingBottom,
  paddingStart,
  paddingX,
  paddingY,
  textAlign,
  textColor,
  textDecoration,
  textReset,
  ...props
}) => (
  <Component
    className={classNames(
      tone === 'muted' ? 'text-muted' : undefined,
      variant === 'lead' ? 'lead' : undefined,
      variant === 'small' ? 'small' : undefined,
      textClassNames({
        fontSize,
        fontWeight,
        textColor,
        textDecoration,
        textReset,
      }),
      layoutClassNames({
        margin,
        marginTop,
        marginEnd,
        marginBottom,
        marginStart,
        marginX,
        marginY,
        padding,
        paddingTop,
        paddingEnd,
        paddingBottom,
        paddingStart,
        paddingX,
        paddingY,
        textAlign,
      }),
      className,
    )}
    {...props}
  >
    {children}
  </Component>
);

export default Text;
